import {useDataSource} from "src/core/data-sources/decorators/withData";
import LoyaltyDataSource from "../../user/data-sources/loyalty";

function useLoyalty() {
  return useDataSource(
    {},
    {
      dataSource: rewardsDataSource,
      dataField: "loyalty",
    }
  );
}

const rewardsDataSource = new LoyaltyDataSource();

export default useLoyalty;
